import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const NowPlayingContainer = styled.div`
  width: 100%;
  height: 277px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 10px;
  border-radius: 8px;
  background: ${designTokens.colors.box.primary};
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  background: transparent;

  video {
    display: block;
    height: 168px;
    border-radius: 4px;
    border: 2px solid #0b99ff;
  }
`;

export const YoutubeBadge = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const NowInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h3`
  margin: 0;
  font-size: ${getTypography("korean", "body3").fontSize};
  font-weight: ${getTypography("korean", "body3").fontWeight};
  letter-spacing: ${getTypography("korean", "body3").letterSpacing};
  line-height: ${getTypography("korean", "body3").lineHeight};
  color: ${designTokens.colors.font.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Meta = styled.div`
  font-size: ${getTypography("korean", "body4").fontSize};
  font-weight: ${getTypography("korean", "body4").fontWeight};
  letter-spacing: ${getTypography("korean", "body4").letterSpacing};
  line-height: ${getTypography("korean", "body4").lineHeight};
  color: ${designTokens.colors.font.tertiary};
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Item = styled.li<{ $selected: boolean }>`
  display: flex;
  gap: 24px;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
`;

export const Thumb = styled.div`
  flex-shrink: 0;
  width: 120px;
  height: 67px;
  overflow: hidden;
  border-radius: 4px;
  background: #000;
  align-items: center;
  display: flex;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  gap: 8px;
`;

export const ItemMeta = styled.div`
  font-size: 0.75rem;
  color: ${designTokens.colors.font.tertiary};
  display: flex;
  align-items: center;
`;

export const ItemTitle = styled.div`
  font-size: ${getTypography("korean", "body3").fontSize};
  font-weight: ${getTypography("korean", "body3").fontWeight};
  letter-spacing: ${getTypography("korean", "body3").letterSpacing};
  line-height: ${getTypography("korean", "body3").lineHeight};
  color: ${designTokens.colors.font.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
